// Production builds alias '@faker-js/faker' here (INT-1539). Faker only feeds mock responses that
// production never serves, but module-level mock data still calls it on import, so every call
// returns a value of the type its caller expects rather than pulling ~440KB into the entry bundle.
const valueFor = (namespace, method, args) => {
  const [first] = args
  if (namespace === 'number' || (namespace === 'datatype' && method === 'number')) {
    return typeof first === 'object' && first !== null && 'min' in first ? first.min : 0
  }
  if (namespace === 'datatype' && method === 'boolean') {
    return false
  }
  if (namespace === 'date') {
    return new Date(0)
  }
  if (namespace === 'helpers') {
    if (method === 'arrayElement') {
      return Array.isArray(first) ? first[0] : undefined
    }
    if (method === 'arrayElements' || method === 'multiple') {
      return []
    }
    if (method === 'maybe') {
      return undefined
    }
    return first
  }
  if (namespace === 'finance' || (namespace === 'commerce' && method === 'price')) {
    return '0'
  }
  return ''
}

export const faker = new Proxy(
  {},
  {
    get: (_target, namespace) =>
      namespace === 'seed'
        ? () => undefined
        : new Proxy(
            {},
            {
              get:
                (_ns, method) =>
                (...args) =>
                  valueFor(namespace, method, args),
            }
          ),
  }
)
